import { StatusIndicator } from '@/components/ui/status-indicator.tsx'
import { ProxyStatus } from '@/modules/creators/types.ts'

const colorClassNames: Record<ProxyStatus, string> = {
  AutomationsRunning: 'bg-green-500',
  AutomationsNotRunning: 'bg-yellow-500',
  NotLoggedIn: 'bg-red-500',
  ProxyFailing: 'bg-red-500',
}

const statusMessages: Record<ProxyStatus, string> = {
  AutomationsRunning: 'All automations are running',
  AutomationsNotRunning:
    'No one is currently logged into the OnlyFans account, which may result in certain automations not running',
  NotLoggedIn: 'Please sign in to the OnlyFans account',
  ProxyFailing: 'Your proxy has issues, please check your proxy settings',
}

export const CreatorStatusIndicator = ({ status }: { status: ProxyStatus }) => {
  const colorClassName = colorClassNames[status]
  const statusMessage = statusMessages[status]

  return (
    <StatusIndicator
      colorClassName={colorClassName}
      tooltipContent={statusMessage}
    />
  )
}
